import {
  AROM_ASSESSMENT,
  FUNCTIONAL_REACH_ASSESSMENT,
  mCTSIB_ASSESSMENT,
} from "../../models/Enums";
import { AssessmentKey, FRAssessmentKey } from "./arom-assessment-gif";
import React from "react";

interface Props {
  phaseNo: string;
  aromAssessmentIndex: AssessmentKey | FRAssessmentKey | mCTSIB_ASSESSMENT;
  isOpen: boolean;
}
const AROMStartModal: React.FC<Props> = ({
  phaseNo,
  aromAssessmentIndex,
  isOpen,
}) => {
  const pathTags: { [key: string]: { [key: string]: JSX.Element } } = {
    "1": {
      [AROM_ASSESSMENT.Shoulder_AAA]: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="401"
          height="400"
          viewBox="0 0 401 400"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M200.946 0C90.4888 0 0.945801 89.543 0.945801 200C0.945801 310.457 90.4888 400 200.946 400C311.403 400 400.946 310.457 400.946 200C400.946 89.543 311.403 0 200.946 0Z"
            fill="#0F854C"
          />
          <path
            d="M235.4 123.086C231.455 138.906 217.236 150 200.947 150C184.658 150 170.439 138.906 166.494 123.086L163.056 109.453C161.416 102.773 154.619 98.7109 147.9 100.391C141.181 102.07 137.158 108.828 138.838 115.547L142.236 129.18C146.533 146.367 157.939 160.273 172.822 168.086V287.5C172.822 294.414 178.408 300 185.322 300C192.236 300 197.822 294.414 197.822 287.5V237.5H204.072V287.5C204.072 294.414 209.658 300 216.572 300C223.486 300 229.072 294.414 229.072 287.5V168.086C243.955 160.273 255.361 146.367 259.658 129.18L263.056 115.547C264.736 108.867 260.674 102.07 253.955 100.391C247.236 98.7109 240.478 102.773 238.838 109.453L235.439 123.086H235.4ZM200.947 137.5C205.92 137.5 210.689 135.525 214.205 132.008C217.722 128.492 219.697 123.723 219.697 118.75C219.697 113.777 217.722 109.008 214.205 105.492C210.689 101.975 205.92 100 200.947 100C195.974 100 191.205 101.975 187.689 105.492C184.172 109.008 182.197 113.777 182.197 118.75C182.197 123.723 184.172 128.492 187.689 132.008C191.205 135.525 195.974 137.5 200.947 137.5Z"
            fill="white"
          />
        </svg>
      ),
    },
    "3": {
      [AROM_ASSESSMENT.Left_Shoulder_FAE]: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="401"
          height="400"
          viewBox="0 0 401 400"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M200.922 0C90.4649 0 0.921875 89.543 0.921875 200C0.921875 310.457 90.4649 400 200.922 400C311.379 400 400.922 310.457 400.922 200C400.922 89.543 311.379 0 200.922 0Z"
            fill="#0F854C"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M219.776 135.866C209.872 135.866 201.843 127.837 201.843 117.933C201.843 108.029 209.872 100 219.776 100C229.68 100 237.709 108.029 237.709 117.933C237.709 127.837 229.68 135.866 219.776 135.866ZM216.296 139.897C207.203 141.275 200.949 149.763 202.327 158.856C202.848 162.296 203.429 165.146 203.899 167.45C203.979 167.842 204.055 168.217 204.128 168.578C204.629 171.064 205.003 173.103 205.269 175.684C205.816 180.981 206 189.465 204.74 207.734C204.5 211.214 205.347 214.518 206.992 217.313C204.797 258.554 206.892 283.58 208.47 291.705C209.549 297.261 214.927 300.89 220.483 299.811C226.039 298.732 229.668 293.354 228.589 287.798C227.539 282.39 225.518 261.328 227.16 224.491C233.097 222.279 237.501 216.758 237.966 210.026C239.268 191.148 239.239 180.418 238.398 172.265C237.97 168.121 237.356 164.877 236.776 161.999C236.685 161.545 236.596 161.107 236.509 160.681L236.509 160.68L236.509 160.68C236.044 158.394 235.641 156.412 235.255 153.867C233.877 144.774 225.389 138.52 216.296 139.897Z"
            fill="white"
          />
          <path
            d="M217.907 150.627C221.724 149.159 226.008 151.063 227.476 154.88C228.944 158.697 227.04 162.981 223.223 164.449C217.167 166.778 207.893 169.465 197.606 169.869C187.297 170.273 175.494 168.393 165.057 161.026C161.716 158.667 160.919 154.047 163.278 150.706C165.636 147.365 170.256 146.568 173.597 148.927C180.581 153.857 188.846 155.392 197.025 155.071C205.227 154.749 212.861 152.567 217.907 150.627Z"
            fill="white"
            stroke="#0F854C"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      ),
      [AROM_ASSESSMENT.Left_Elbow_FAE]: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="401"
          height="400"
          viewBox="0 0 401 400"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M200.922 0C90.4649 0 0.921875 89.543 0.921875 200C0.921875 310.457 90.4649 400 200.922 400C311.379 400 400.922 310.457 400.922 200C400.922 89.543 311.379 0 200.922 0Z"
            fill="#0F854C"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M207.926 135.866C198.022 135.866 189.993 127.837 189.993 117.933C189.993 108.029 198.022 100 207.926 100C217.83 100 225.859 108.029 225.859 117.933C225.859 127.837 217.83 135.866 207.926 135.866ZM204.443 139.897C195.35 141.275 189.096 149.763 190.474 158.856C190.995 162.296 191.576 165.146 192.046 167.45L192.047 167.454C192.126 167.844 192.203 168.218 192.275 168.578C192.776 171.064 193.15 173.103 193.416 175.684C193.963 180.981 194.147 189.465 192.887 207.734C192.647 211.212 193.494 214.514 195.136 217.308C192.942 258.552 195.036 283.58 196.614 291.705C197.693 297.261 203.072 300.89 208.628 299.811C214.183 298.732 217.812 293.354 216.734 287.798C215.683 282.39 213.662 261.328 215.304 224.493C221.243 222.281 225.648 216.759 226.113 210.026C227.415 191.148 227.386 180.418 226.545 172.265C226.117 168.121 225.503 164.877 224.923 161.999C224.832 161.545 224.743 161.107 224.656 160.681L224.656 160.68C224.191 158.394 223.788 156.412 223.402 153.867C222.025 144.774 213.536 138.52 204.443 139.897Z"
            fill="white"
          />
          <path
            d="M216.35 158.151C216.35 153.892 212.917 150.429 208.668 150.429C204.42 150.429 200.986 153.892 200.986 158.151V176.975C200.986 180.141 198.437 182.698 195.304 182.698H180.604C176.356 182.698 172.922 186.161 172.922 190.42C172.922 194.68 176.356 198.143 180.604 198.143H195.304C206.934 198.143 216.35 188.66 216.35 176.975V158.151Z"
            fill="white"
            stroke="#0F854C"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      [AROM_ASSESSMENT.Left_Shoulder_IAE_Rotation]: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="401"
          height="400"
          viewBox="0 0 401 400"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M200.922 0C90.4649 0 0.921875 89.543 0.921875 200C0.921875 310.457 90.4649 400 200.922 400C311.379 400 400.922 310.457 400.922 200C400.922 89.543 311.379 0 200.922 0Z"
            fill="#0F854C"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M222.422 164.533C222.422 152.812 212.92 143.311 201.2 143.311C189.479 143.311 179.978 152.812 179.978 164.533V218.468C179.978 218.469 179.977 218.47 179.975 218.47C179.974 218.47 179.973 218.471 179.973 218.472V287.424C179.973 294.369 185.603 300 192.549 300C199.494 300 205.125 294.369 205.125 287.424V219.474C205.125 218.919 204.676 218.47 204.121 218.47C203.08 218.47 202.685 217.003 203.551 216.424C214.93 208.81 222.422 195.841 222.422 181.122V164.533ZM203.228 149.265C195.861 149.625 190.249 154.755 190.693 160.725C191.184 167.34 190.493 185.94 183.558 203.46C181.304 209.155 185.173 215.252 192.2 217.078C199.227 218.905 206.751 215.769 209.005 210.075C217.181 189.418 218.007 168.03 217.368 159.424C216.925 153.454 210.594 148.906 203.228 149.265ZM195.4 160.495C195.113 156.632 198.745 153.313 203.511 153.08C208.278 152.848 212.374 155.791 212.661 159.653C213.274 167.908 212.472 188.804 204.514 208.907C203.056 212.592 198.187 214.621 193.641 213.439C189.094 212.257 186.59 208.312 188.048 204.627C195.202 186.554 195.917 167.462 195.4 160.495Z"
            fill="white"
          />
          <rect
            x="186.34"
            y="204"
            width="20.9212"
            height="10.309"
            rx="5.1545"
            fill="#0F854C"
          />
          <rect
            x="193.266"
            y="173.842"
            width="20.9212"
            height="35.7441"
            rx="10.4606"
            transform="rotate(14.8147 193.266 173.842)"
            fill="#0F854C"
          />
          <ellipse
            cx="18.7466"
            cy="18.8721"
            rx="18.7466"
            ry="18.8721"
            transform="matrix(-1 0 0 1 220.299 100)"
            fill="white"
          />
          <path
            d="M212.719 185.362V162.54C212.719 157.343 208.438 153.167 203.243 153.295C198.226 153.419 194.223 157.521 194.223 162.54V177.406V178.928L194.396 185.6C194.526 190.596 198.635 194.567 203.633 194.524C208.663 194.482 212.719 190.392 212.719 185.362Z"
            fill="white"
          />
        </svg>
      ),
    },

    "2": {
      [AROM_ASSESSMENT.Right_Shoulder_FAE]: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="401"
          height="400"
          viewBox="0 0 401 400"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M200.922 0C90.4649 0 0.921875 89.543 0.921875 200C0.921875 310.457 90.4649 400 200.922 400C311.379 400 400.922 310.457 400.922 200C400.922 89.543 311.379 0 200.922 0Z"
            fill="#0F854C"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M182.217 135.866C192.121 135.866 200.15 127.837 200.15 117.933C200.15 108.029 192.121 100 182.217 100C172.312 100 164.283 108.029 164.283 117.933C164.283 127.837 172.312 135.866 182.217 135.866ZM185.696 139.897C194.789 141.275 201.044 149.763 199.666 158.856C199.145 162.296 198.563 165.146 198.094 167.45C198.014 167.842 197.937 168.217 197.864 168.578C197.364 171.064 196.99 173.103 196.724 175.684C196.177 180.981 195.992 189.465 197.252 207.734C197.492 211.214 196.645 214.518 195.001 217.313C197.195 258.554 195.1 283.58 193.522 291.705C192.444 297.261 187.065 300.89 181.509 299.811C175.954 298.732 172.324 293.354 173.403 287.798C174.454 282.39 176.475 261.328 174.833 224.491C168.896 222.279 164.491 216.758 164.027 210.026C162.725 191.148 162.754 180.418 163.595 172.265C164.023 168.121 164.636 164.877 165.216 161.999C165.308 161.545 165.397 161.107 165.484 160.681L165.484 160.68L165.484 160.68C165.949 158.394 166.352 156.412 166.737 153.867C168.115 144.774 176.603 138.52 185.696 139.897Z"
            fill="white"
          />
          <path
            d="M184.086 150.626C180.269 149.158 175.985 151.063 174.517 154.879C173.049 158.696 174.953 162.981 178.77 164.449C184.826 166.778 194.1 169.464 204.386 169.868C214.695 170.273 226.498 168.393 236.936 161.025C240.277 158.667 241.073 154.046 238.715 150.705C236.356 147.364 231.736 146.568 228.395 148.926C221.411 153.856 213.146 155.391 204.967 155.07C196.765 154.748 189.131 152.567 184.086 150.626Z"
            fill="white"
            stroke="#0F854C"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      ),
      [AROM_ASSESSMENT.Right_Elbow_FAE]: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="401"
          height="400"
          viewBox="0 0 401 400"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M200.922 0C90.4649 0 0.921875 89.543 0.921875 200C0.921875 310.457 90.4649 400 200.922 400C311.379 400 400.922 310.457 400.922 200C400.922 89.543 311.379 0 200.922 0Z"
            fill="#0F854C"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M193.136 135.866C203.04 135.866 211.069 127.837 211.069 117.933C211.069 108.029 203.04 100 193.136 100C183.232 100 175.203 108.029 175.203 117.933C175.203 127.837 183.232 135.866 193.136 135.866ZM196.618 139.897C205.711 141.275 211.966 149.763 210.588 158.856C210.067 162.296 209.485 165.146 209.015 167.45L209.015 167.454C208.935 167.844 208.859 168.218 208.786 168.578C208.285 171.064 207.912 173.103 207.645 175.684C207.099 180.981 206.914 189.465 208.174 207.734C208.414 211.212 207.568 214.514 205.925 217.308C208.12 258.552 206.025 283.58 204.447 291.705C203.368 297.261 197.99 300.89 192.434 299.811C186.878 298.732 183.249 293.354 184.328 287.798C185.378 282.39 187.4 261.328 185.757 224.493C179.819 222.281 175.413 216.759 174.949 210.026C173.647 191.148 173.676 180.418 174.517 172.265C174.944 168.121 175.558 164.877 176.138 161.999C176.23 161.545 176.319 161.107 176.405 160.681L176.405 160.68C176.87 158.394 177.274 156.412 177.659 153.867C179.037 144.774 187.525 138.52 196.618 139.897Z"
            fill="white"
          />
          <path
            d="M184.711 158.151C184.711 153.892 188.145 150.429 192.393 150.429C196.641 150.429 200.075 153.892 200.075 158.151V176.975C200.075 180.141 202.625 182.698 205.757 182.698H220.458C224.706 182.698 228.14 186.161 228.14 190.42C228.14 194.68 224.706 198.143 220.458 198.143H205.757C194.128 198.143 184.711 188.66 184.711 176.975V158.151Z"
            fill="white"
            stroke="#0F854C"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      [AROM_ASSESSMENT.Right_Shoulder_IAE_Rotation]: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="401"
          height="400"
          viewBox="0 0 401 400"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M200.922 0C90.4649 0 0.921875 89.543 0.921875 200C0.921875 310.457 90.4649 400 200.922 400C311.379 400 400.922 310.457 400.922 200C400.922 89.543 311.379 0 200.922 0Z"
            fill="#0F854C"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M179.973 164.533C179.973 152.812 189.474 143.311 201.195 143.311C212.915 143.311 222.417 152.812 222.417 164.533V218.468C222.417 218.469 222.418 218.47 222.419 218.47C222.421 218.47 222.422 218.471 222.422 218.472V287.424C222.422 294.369 216.791 300 209.846 300C202.9 300 197.27 294.369 197.27 287.424V219.474C197.27 218.919 197.719 218.47 198.273 218.47C199.315 218.47 199.709 217.003 198.844 216.424C187.465 208.81 179.973 195.841 179.973 181.122V164.533ZM199.167 149.265C206.533 149.625 212.145 154.755 211.702 160.725C211.211 167.34 211.902 185.94 218.837 203.46C221.091 209.155 217.221 215.252 210.194 217.078C203.167 218.905 195.644 215.769 193.39 210.075C185.213 189.418 184.387 168.03 185.026 159.424C185.469 153.454 191.8 148.906 199.167 149.265ZM206.995 160.495C207.281 156.632 203.65 153.313 198.883 153.08C194.117 152.848 190.021 155.791 189.734 159.653C189.121 167.908 189.923 188.804 197.88 208.907C199.339 212.592 204.207 214.621 208.754 213.439C213.301 212.257 215.805 208.312 214.346 204.627C207.192 186.554 206.477 167.462 206.995 160.495Z"
            fill="white"
          />
          <rect
            width="20.9212"
            height="10.309"
            rx="5.1545"
            transform="matrix(-1 0 0 1 216.055 204)"
            fill="#0F854C"
          />
          <rect
            width="20.9212"
            height="35.7441"
            rx="10.4606"
            transform="matrix(-0.966758 0.255694 0.255694 0.966758 209.129 173.842)"
            fill="#0F854C"
          />
          <ellipse
            cx="200.842"
            cy="118.872"
            rx="18.7466"
            ry="18.8721"
            fill="white"
          />
          <path
            d="M189.676 185.362V162.539C189.676 157.343 193.957 153.166 199.152 153.294C204.169 153.418 208.171 157.521 208.171 162.539V177.406V178.927L207.998 185.599C207.869 190.595 203.759 194.566 198.762 194.524C193.731 194.482 189.676 190.392 189.676 185.362Z"
            fill="white"
          />
        </svg>
      ),
    },
  };

  const FRpathTags: { [key: string]: { [key: string]: JSX.Element } } = {
    "1": {
      [FUNCTIONAL_REACH_ASSESSMENT.Left_Reach]: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="401"
          height="400"
          viewBox="0 0 401 400"
          fill="none"
        >
          <path
            d="M200.5 0C90.043 0 0.5 89.543 0.5 200C0.5 310.457 90.043 400 200.5 400C310.957 400 400.5 310.457 400.5 200C400.5 89.543 310.957 3.10884e-06 200.5 0Z"
            fill="#0F854C"
          />
          <path
            d="M210.166 122.688C203.975 122.688 198.037 120.228 193.659 115.85C189.282 111.472 186.822 105.535 186.822 99.3438C186.822 93.1526 189.282 87.215 193.659 82.8372C198.037 78.4594 203.975 76 210.166 76C216.357 76 222.295 78.4594 226.673 82.8372C231.05 87.215 233.51 93.1526 233.51 99.3438C233.51 105.535 231.05 111.472 226.673 115.85C222.295 120.228 216.357 122.688 210.166 122.688ZM214.057 138.25C231.224 138.25 245.182 152.208 245.182 169.375V216.062V216.354V309.438C245.182 318.046 238.227 325 229.619 325C221.011 325 214.057 318.046 214.057 309.438V247.188H206.275V309.438C206.275 318.046 199.321 325 190.713 325C182.105 325 175.15 318.046 175.15 309.438V168.402H157.643C150.834 168.402 144.463 168.402 139.162 168.402H133.326C124.718 168.402 115.818 162.566 115.818 153.812C115.818 145.059 121.8 138.25 130.408 138.25H146.943H165.327C178.068 138.25 184.828 138.25 198.154 138.25H214.057Z"
            fill="white"
          />
        </svg>
      ),
    },
    "2": {
      [FUNCTIONAL_REACH_ASSESSMENT.Right_Reach]: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="401"
          height="400"
          viewBox="0 0 401 400"
          fill="none"
        >
          <path
            d="M200.5 0C310.957 0 400.5 89.543 400.5 200C400.5 310.457 310.957 400 200.5 400C90.043 400 0.5 310.457 0.5 200C0.500003 89.543 90.043 3.10884e-06 200.5 0Z"
            fill="#0F854C"
          />
          <path
            d="M190.834 122.688C197.025 122.688 202.963 120.228 207.341 115.85C211.718 111.472 214.178 105.535 214.178 99.3438C214.178 93.1526 211.718 87.215 207.341 82.8372C202.963 78.4594 197.025 76 190.834 76C184.643 76 178.705 78.4594 174.327 82.8372C169.95 87.215 167.49 93.1526 167.49 99.3438C167.49 105.535 169.95 111.472 174.327 115.85C178.705 120.228 184.643 122.688 190.834 122.688ZM186.943 138.25C169.776 138.25 155.818 152.208 155.818 169.375V216.062V216.354V309.438C155.818 318.046 162.773 325 171.381 325C179.989 325 186.943 318.046 186.943 309.438V247.188H194.725V309.438C194.725 318.046 201.679 325 210.287 325C218.895 325 225.85 318.046 225.85 309.438V168.402H243.357C250.166 168.402 256.537 168.402 261.838 168.402H267.674C276.282 168.402 285.182 162.566 285.182 153.812C285.182 145.059 279.2 138.25 270.592 138.25H254.057H235.673C222.932 138.25 216.172 138.25 202.846 138.25H186.943Z"
            fill="white"
          />
        </svg>
      ),
    },
    "3": {
      [FUNCTIONAL_REACH_ASSESSMENT.Forward_Reach]: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="401"
          height="400"
          viewBox="0 0 401 400"
          fill="none"
        >
          <path
            d="M200.5 0C310.957 0 400.5 89.543 400.5 200C400.5 310.457 310.957 400 200.5 400C90.043 400 0.5 310.457 0.5 200C0.500003 89.543 90.043 3.10884e-06 200.5 0Z"
            fill="#0F854C"
          />
          <path
            d="M197.435 134.92C203.293 129.062 212.791 129.062 218.649 134.92L236.671 152.941C227.08 153.072 219.298 152.482 215.125 151.895C207.15 150.772 199.775 156.284 198.654 164.205C197.533 172.126 203.089 179.458 211.064 180.58C212.527 180.786 214.27 180.987 216.255 181.17L169.417 228.008V311.594C169.417 317.117 164.939 321.594 159.417 321.594H152.15C146.627 321.594 142.15 317.117 142.15 311.594V211.8H142.681L142.224 211.343C136.366 205.485 136.366 195.988 142.224 190.13L197.435 134.92ZM260.704 155.415C266.696 154.186 272.548 158.016 273.774 163.967C274.999 169.918 271.134 175.739 265.142 176.968C256.503 178.739 234.75 181.174 212.878 177.513C207.409 176.597 203.564 171.842 203.663 166.494C203.648 165.977 203.676 165.452 203.751 164.923C203.943 163.563 204.422 162.313 205.116 161.224C207.357 157.319 211.883 155.022 216.597 155.812C235.148 158.917 254.062 156.777 260.704 155.415ZM247.771 90C261.714 90 273.017 101.378 273.017 115.414C273.017 129.45 261.714 140.829 247.771 140.829C233.828 140.829 222.525 129.45 222.525 115.414C222.525 101.378 233.828 90 247.771 90Z"
            fill="white"
          />
        </svg>
      ),
    },
  };

  const mCTSIBpathTags: { [key: string]: { [key: string]: JSX.Element } } = {
    "1": {
      [mCTSIB_ASSESSMENT.Open_Eyes]: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="400"
          height="400"
          viewBox="0 0 400 400"
          fill="none"
        >
          <path
            d="M200 0C310.457 0 400 89.543 400 200C400 310.457 310.457 400 200 400C89.543 400 0 310.457 0 200C3.10965e-06 89.543 89.543 3.10884e-06 200 0Z"
            fill="#0F854C"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M110 225.608C152.195 298.264 248.03 298.264 290 225.608C248.03 153.176 152.195 152.952 110 225.608ZM200 257.675C182.269 257.675 167.905 243.324 167.905 225.608C167.905 207.893 182.269 193.541 200 193.541C217.731 193.541 232.095 207.893 232.095 225.608C232.095 243.324 217.731 257.675 200 257.675Z"
            fill="white"
          />
          <path
            d="M272.553 178.824C273.776 178.824 274.999 178.416 275.814 177.601L287.839 168.226C290.285 166.391 290.692 162.927 288.858 160.481C287.024 158.035 283.559 157.628 281.113 159.462L269.089 169.245C266.643 171.079 266.235 174.544 268.07 176.989C269.292 178.212 270.923 178.824 272.553 178.824Z"
            fill="white"
          />
          <path
            d="M246.875 156.202C248.709 156.202 250.543 155.183 251.562 153.553L259.307 140.305C260.937 137.656 259.918 134.395 257.473 132.764C254.823 131.134 251.562 132.153 249.932 134.599L242.187 147.846C240.557 150.496 241.576 153.756 244.021 155.387C245.04 155.998 246.059 156.202 246.875 156.202Z"
            fill="white"
          />
          <path
            d="M216.306 144.992C218.955 144.992 221.197 143.158 221.605 140.508L224.254 125.427C224.866 122.37 222.828 119.72 219.771 119.109C216.917 118.497 214.064 120.535 213.656 123.389L211.007 138.47C210.395 141.527 212.434 144.177 215.491 144.788C215.694 144.992 215.898 144.992 216.306 144.992Z"
            fill="white"
          />
          <path
            d="M183.895 144.992C184.303 144.992 184.507 144.992 184.915 144.992C187.972 144.381 189.806 141.527 189.398 138.674L186.749 123.592C186.137 120.535 183.284 118.701 180.431 119.109C177.374 119.72 175.539 122.37 175.947 125.427L178.596 140.508C179.004 143.158 181.246 144.992 183.895 144.992Z"
            fill="white"
          />
          <path
            d="M153.331 156.202C154.35 156.202 155.165 155.998 156.184 155.387C158.834 153.756 159.649 150.496 158.019 147.846L150.07 134.802C148.44 132.153 145.179 131.338 142.529 132.968C139.88 134.599 139.064 137.859 140.695 140.509L148.44 153.756C149.662 155.387 151.293 156.202 153.331 156.202Z"
            fill="white"
          />
          <path
            d="M127.648 178.824C129.279 178.824 130.909 178.009 131.928 176.786C133.763 174.34 133.355 171.079 130.909 169.041L118.885 159.666C116.439 157.832 112.974 158.239 111.14 160.685C109.306 163.131 109.713 166.391 112.159 168.43L124.184 177.805C125.203 178.62 126.425 178.824 127.648 178.824Z"
            fill="white"
          />
        </svg>
      ),
    },
    "2": {
      [mCTSIB_ASSESSMENT.Closed_Eyes]: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="400"
          height="400"
          viewBox="0 0 400 400"
          fill="none"
        >
          <path
            d="M200 0C310.457 0 400 89.543 400 200C400 310.457 310.457 400 200 400C89.543 400 0 310.457 0 200C3.10965e-06 89.543 89.543 3.10884e-06 200 0Z"
            fill="#0F854C"
          />
          <path
            d="M272.514 195.592C273.737 195.592 274.96 195.999 275.775 196.815L287.8 206.19C290.246 208.024 290.653 211.489 288.819 213.934C286.985 216.38 283.52 216.788 281.074 214.953L269.05 205.171C266.604 203.336 266.196 199.872 268.031 197.426C269.253 196.203 270.884 195.592 272.514 195.592Z"
            fill="white"
          />
          <path
            d="M246.836 218.213C248.67 218.213 250.504 219.232 251.523 220.862L259.268 234.11C260.898 236.759 259.879 240.02 257.434 241.651C254.784 243.281 251.523 242.262 249.893 239.816L242.148 226.569C240.518 223.919 241.537 220.659 243.982 219.028C245.001 218.417 246.02 218.213 246.836 218.213Z"
            fill="white"
          />
          <path
            d="M216.267 229.423C218.916 229.423 221.158 231.257 221.566 233.907L224.215 248.988C224.827 252.045 222.789 254.695 219.732 255.306C216.878 255.918 214.025 253.88 213.617 251.026L210.968 235.945C210.356 232.888 212.395 230.238 215.452 229.627C215.655 229.423 215.859 229.423 216.267 229.423Z"
            fill="white"
          />
          <path
            d="M183.86 229.423C184.268 229.423 184.472 229.423 184.879 229.423C187.936 230.034 189.771 232.888 189.363 235.741L186.714 250.823C186.102 253.88 183.249 255.714 180.396 255.306C177.338 254.695 175.504 252.045 175.912 248.988L178.561 233.907C178.969 231.257 181.211 229.423 183.86 229.423Z"
            fill="white"
          />
          <path
            d="M153.292 218.213C154.311 218.213 155.126 218.417 156.145 219.028C158.795 220.659 159.61 223.919 157.979 226.569L150.031 239.613C148.401 242.262 145.14 243.077 142.49 241.447C139.841 239.816 139.025 236.556 140.656 233.906L148.401 220.659C149.623 219.028 151.254 218.213 153.292 218.213Z"
            fill="white"
          />
          <path
            d="M127.609 195.592C129.24 195.592 130.87 196.407 131.889 197.63C133.724 200.076 133.316 203.336 130.87 205.375L118.846 214.75C116.4 216.584 112.935 216.176 111.101 213.731C109.267 211.285 109.674 208.024 112.12 205.986L124.145 196.611C125.164 195.796 126.386 195.592 127.609 195.592Z"
            fill="white"
          />
          <path
            d="M199.961 195.459C163.589 195.459 135.713 168.902 122.439 145L109.961 151.639C129.607 186.961 164.651 209.8 199.961 209.8C235.536 209.8 270.58 187.226 289.961 151.639L277.483 145C264.209 168.902 236.598 195.459 199.961 195.459Z"
            fill="white"
          />
        </svg>
      ),
    },
    "3": {
      [mCTSIB_ASSESSMENT.Foam_Open_Eyes]: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="400"
          height="400"
          viewBox="0 0 400 400"
          fill="none"
        >
          <path
            d="M200 0C310.457 0 400 89.543 400 200C400 310.457 310.457 400 200 400C89.543 400 0 310.457 0 200C3.10965e-06 89.543 89.543 3.10884e-06 200 0Z"
            fill="#0F854C"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M110 225.608C152.195 298.264 248.03 298.264 290 225.608C248.03 153.176 152.195 152.952 110 225.608ZM200 257.675C182.269 257.675 167.905 243.324 167.905 225.608C167.905 207.893 182.269 193.541 200 193.541C217.731 193.541 232.095 207.893 232.095 225.608C232.095 243.324 217.731 257.675 200 257.675Z"
            fill="white"
          />
          <path
            d="M272.553 178.824C273.776 178.824 274.999 178.416 275.814 177.601L287.839 168.226C290.285 166.391 290.692 162.927 288.858 160.481C287.024 158.035 283.559 157.628 281.113 159.462L269.089 169.245C266.643 171.079 266.235 174.544 268.07 176.989C269.292 178.212 270.923 178.824 272.553 178.824Z"
            fill="white"
          />
          <path
            d="M246.875 156.202C248.709 156.202 250.543 155.183 251.562 153.553L259.307 140.305C260.937 137.656 259.918 134.395 257.473 132.764C254.823 131.134 251.562 132.153 249.932 134.599L242.187 147.846C240.557 150.496 241.576 153.756 244.021 155.387C245.04 155.998 246.059 156.202 246.875 156.202Z"
            fill="white"
          />
          <path
            d="M216.306 144.992C218.955 144.992 221.197 143.158 221.605 140.508L224.254 125.427C224.866 122.37 222.828 119.72 219.771 119.109C216.917 118.497 214.064 120.535 213.656 123.389L211.007 138.47C210.395 141.527 212.434 144.177 215.491 144.788C215.694 144.992 215.898 144.992 216.306 144.992Z"
            fill="white"
          />
          <path
            d="M183.895 144.992C184.303 144.992 184.507 144.992 184.915 144.992C187.972 144.381 189.806 141.527 189.398 138.674L186.749 123.592C186.137 120.535 183.284 118.701 180.431 119.109C177.374 119.72 175.539 122.37 175.947 125.427L178.596 140.508C179.004 143.158 181.246 144.992 183.895 144.992Z"
            fill="white"
          />
          <path
            d="M153.331 156.202C154.35 156.202 155.165 155.998 156.184 155.387C158.834 153.756 159.649 150.496 158.019 147.846L150.07 134.802C148.44 132.153 145.179 131.338 142.529 132.968C139.88 134.599 139.064 137.859 140.695 140.509L148.44 153.756C149.662 155.387 151.293 156.202 153.331 156.202Z"
            fill="white"
          />
          <path
            d="M127.648 178.824C129.279 178.824 130.909 178.009 131.928 176.786C133.763 174.34 133.355 171.079 130.909 169.041L118.885 159.666C116.439 157.832 112.974 158.239 111.14 160.685C109.306 163.131 109.713 166.391 112.159 168.43L124.184 177.805C125.203 178.62 126.425 178.824 127.648 178.824Z"
            fill="white"
          />
        </svg>
      ),
    },
    "4": {
      [mCTSIB_ASSESSMENT.Foam_Closed_Eyes]: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="400"
          height="400"
          viewBox="0 0 400 400"
          fill="none"
        >
          <path
            d="M200 0C310.457 0 400 89.543 400 200C400 310.457 310.457 400 200 400C89.543 400 0 310.457 0 200C3.10965e-06 89.543 89.543 3.10884e-06 200 0Z"
            fill="#0F854C"
          />
          <path
            d="M272.514 195.592C273.737 195.592 274.96 195.999 275.775 196.815L287.8 206.19C290.246 208.024 290.653 211.489 288.819 213.934C286.985 216.38 283.52 216.788 281.074 214.953L269.05 205.171C266.604 203.336 266.196 199.872 268.031 197.426C269.253 196.203 270.884 195.592 272.514 195.592Z"
            fill="white"
          />
          <path
            d="M246.836 218.213C248.67 218.213 250.504 219.232 251.523 220.862L259.268 234.11C260.898 236.759 259.879 240.02 257.434 241.651C254.784 243.281 251.523 242.262 249.893 239.816L242.148 226.569C240.518 223.919 241.537 220.659 243.982 219.028C245.001 218.417 246.02 218.213 246.836 218.213Z"
            fill="white"
          />
          <path
            d="M216.267 229.423C218.916 229.423 221.158 231.257 221.566 233.907L224.215 248.988C224.827 252.045 222.789 254.695 219.732 255.306C216.878 255.918 214.025 253.88 213.617 251.026L210.968 235.945C210.356 232.888 212.395 230.238 215.452 229.627C215.655 229.423 215.859 229.423 216.267 229.423Z"
            fill="white"
          />
          <path
            d="M183.86 229.423C184.268 229.423 184.472 229.423 184.879 229.423C187.936 230.034 189.771 232.888 189.363 235.741L186.714 250.823C186.102 253.88 183.249 255.714 180.396 255.306C177.338 254.695 175.504 252.045 175.912 248.988L178.561 233.907C178.969 231.257 181.211 229.423 183.86 229.423Z"
            fill="white"
          />
          <path
            d="M153.292 218.213C154.311 218.213 155.126 218.417 156.145 219.028C158.795 220.659 159.61 223.919 157.979 226.569L150.031 239.613C148.401 242.262 145.14 243.077 142.49 241.447C139.841 239.816 139.025 236.556 140.656 233.906L148.401 220.659C149.623 219.028 151.254 218.213 153.292 218.213Z"
            fill="white"
          />
          <path
            d="M127.609 195.592C129.24 195.592 130.87 196.407 131.889 197.63C133.724 200.076 133.316 203.336 130.87 205.375L118.846 214.75C116.4 216.584 112.935 216.176 111.101 213.731C109.267 211.285 109.674 208.024 112.12 205.986L124.145 196.611C125.164 195.796 126.386 195.592 127.609 195.592Z"
            fill="white"
          />
          <path
            d="M199.961 195.459C163.589 195.459 135.713 168.902 122.439 145L109.961 151.639C129.607 186.961 164.651 209.8 199.961 209.8C235.536 209.8 270.58 187.226 289.961 151.639L277.483 145C264.209 168.902 236.598 195.459 199.961 195.459Z"
            fill="white"
          />
        </svg>
      ),
    },
  };

  if (isOpen) {
    return (
      <div className="assessmet-complete-wrap counter-center-sec">
        <div className="assessmnet-text-wrap">
          <p
            style={{
              fontSize: "64px",
              fontWeight: "700",
              lineHeight: "87.16px",
              textAlign: "center",
              marginBottom: "50px",
              color: "white",
            }}
          >
            {sessionStorage.getItem("selectedAssesment") === "55"
              ? "Start"
              : "Go"}
          </p>
          {sessionStorage.getItem("selectedAssesment") === "55"
            ? pathTags[phaseNo][aromAssessmentIndex]
            : sessionStorage.getItem("selectedAssesment") === "1"
            ? mCTSIBpathTags[phaseNo][aromAssessmentIndex]
            : FRpathTags[phaseNo][aromAssessmentIndex]}
        </div>
      </div>
    );
  }
  return <React.Fragment />;
};
export default AROMStartModal;
